
export default {
    add(marks,tagname,filename){
        if(!marks) return
        if(marks.findIndex(item=>{return item.name==tagname})==-1){
            marks.unshift({name:tagname,value:[]})
        }
        let tag=marks.find(item=>{return item.name==tagname})
        let tagarr=tag.value
        let i=tagarr.indexOf(filename)
        if(i==-1){
            tagarr.push(filename)
        }
    },
    remove(marks,tagname,filename){
        if(!marks) return
        if(marks.findIndex(item=>{return item.name==tagname})==-1){
            marks.unshift({name:tagname,value:[]})
        }
        let tag=marks.find(item=>{return item.name==tagname})
        let tagarr=tag.value
        let i=tagarr.indexOf(filename)
        if(i!=-1){
            tagarr.splice(i,1)
        }
    },
    exist(marks,tagname,filename){
        if(!marks) return false
        if(marks.findIndex(item=>{return item.name==tagname})==-1){
            marks.unshift({name:tagname,value:[]})
        }
        let tag=marks.find(item=>{return item.name==tagname})
        let tagarr=tag.value
        let i=tagarr.indexOf(filename)
        if(i!=-1){
            return true
        }else{
            return false
        }
    },
    calc_tagcount(marks, tagname,returnarr=false){//计算相应tag标记的数量
        if(!marks){
            if(returnarr){
                return []
            }else{
                return 0
            }
        }
        if(tagname=='已标记'){
            return this.calc_tagged(marks,returnarr)
        }
        if(marks.findIndex(item=>{return item.name==tagname})==-1){
            marks.unshift({name:tagname,value:[]})
        }
        let tag=marks.find(item=>{return item.name==tagname})
        let tagarr=tag.value

        tagarr=this.unique5(tagarr)

        if(returnarr){
            return tagarr
        }else{
            return tagarr.length
        }
    },
    calc_tagged(marks,returnarr=false){//已有标记的所有
        let tmp=[]
        marks.forEach(item => {
            if(item.name!='推荐' && item.value.length!=0){
                tmp=tmp.concat(item.value)
            }
        });
        tmp=this.unique5(tmp)
        if(returnarr){
            return tmp
        }else{
            return tmp.length
        }
    },
    getfiles_by_tagname(tagname,marks,files){//files为服务器oss获得的文件对象files.filename=文件名
        let tagarr=this.calc_tagcount(marks,tagname,true)
        console.log('getfiles_by_tagname',tagarr)
        let newfiles=[]
        tagarr.forEach(item=>{//item=文件名
            let tmp=files.find(file=>file.filename==item)
            if(tmp)
            newfiles.push(tmp)
        })
        newfiles.sort(function (a, b) {
            return a.filename.toLocaleLowerCase().localeCompare(b.filename.toLocaleLowerCase())
        })
        return newfiles
    },
    //获取未标记的
    getfiles_by_tagname_not_mark(tagname,marks,files){//files为服务器oss获得的文件对象files.filename=文件名
        let tagarr=this.calc_tagcount(marks,'已标记',true)
        let oldfiles=Object.assign([],files)
        tagarr.forEach(item=>{//item=文件名
            let index=oldfiles.findIndex(file=>file.filename==item)
            if(index!=-1)
            oldfiles.splice(index,1)
        })
        return oldfiles
    },
    unique5(arr) {
        var x = new Set(arr);
        return [...x];
    },
}